import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadCardsAppTopbarMobileNudgeComponent } from './download-cards-app-topbar-mobile-nudge.component';

@NgModule({
  declarations: [
    DownloadCardsAppTopbarMobileNudgeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DownloadCardsAppTopbarMobileNudgeComponent
  ]
})
export class DownloadCardsAppTopbarMobileNudgeModule { }